<template>
	<div>
		<br/>
		<el-row :gutter="10">
			<el-col align="right">
				<el-button type="primary" @click="addPreviosSuppliers()">Agregar</el-button>
			</el-col>
		</el-row>
		<br/>
		<el-table
				:data="[requestForm]"
				style="width: 100%">

			<el-table-column
					prop="date"
					label="Tipo"
					min-width="150">

				<template slot-scope="scope">

					<el-select
							:disabled="onlyRead== true ? true: false"
							style="width:100%"
							v-model="scope.row.old_provider_cat_agreement_type_id"
							filterable
							clearable
							placeholder="Seleccionar">
						<el-option
								v-for="(item,key) in catalogs.catAgreementType"
								:key="key"
								:label="item.name"
								:value="item.id">
						</el-option>
					</el-select>
				</template>
			</el-table-column>

			<el-table-column
					prop="date"
					label="Proveedor"
					min-width="150">

				<template slot-scope="scope">

					<el-input v-model="scope.row.old_provider_name"
					          :disabled="onlyRead== true ? true: false"
					          placeholder=""/>

				</template>
			</el-table-column>

			<el-table-column label="Periodo">
				<el-table-column
						prop="periodStart"
						label="Inicio"
						min-width="120">

					<template slot-scope="scope">
						<el-date-picker
								:disabled="onlyRead== true ? true: false"
								:editable="false"
								@change="scope.row.old_provider_period_end = null"
								v-model="scope.row.old_provider_period_start"
								type="date"
								placeholder="Selecciona una fecha"
								style="width: 100%"
								format="dd/MM/yyyy"
								value-format="yyyy-MM-dd">
						</el-date-picker>
					</template>


				</el-table-column>
				<el-table-column
						prop="periodEnd"
						label="Fin"
						min-width="120">

					<template slot-scope="scope">
						<el-date-picker
								:picker-options="pickerOptions(scope.row.old_provider_period_start)"
								:disabled="scope.row.old_provider_cat_agreement_type_id == 2 || onlyRead== true ? true: false"
								:editable="false"
								v-model="scope.row.old_provider_period_end"
								type="date"
								placeholder="Selecciona una fecha"
								style="width: 100%"
								format="dd/MM/yyyy"
								value-format="yyyy-MM-dd">
						</el-date-picker>
					</template>
				</el-table-column>
			</el-table-column>


			<el-table-column
					prop="monthlyCost"
					label="Costo Mensual"
					min-width="210">
				<template slot-scope="scope">



					<vue-numeric currency="$"
					             :disabled="onlyRead== true ? true: false"
					             class="el-input__inner"
					             separator=","
					             v-model="scope.row.old_provider_monthly_cost"
					             :precision="2"
					></vue-numeric>

				</template>
			</el-table-column>


			<el-table-column label="Folio de autorización (Plurianual SHCP)" min-width="250">

				<template slot-scope="scope">
					<el-input v-model="scope.row.folioSHCP"
					          :disabled="scope.row.old_provider_cat_agreement_type_id == 2 ||onlyRead== true ? true: false"
					          placeholder="">
					</el-input>
				</template>
			</el-table-column>

			<el-table-column label="" align="center" min-width="80">
			</el-table-column>

		</el-table>

		<el-table
				empty-text=" "
				:data="requestForm.previous_suppliers"
				style="width: 100%;"
				class="custom-table-other">

			<el-table-column
					prop="date"
					label=""
					min-width="150">

				<template slot-scope="scope">

					<el-select
							:disabled="onlyRead== true ? true: false"
							style="width:100%"
							v-model="scope.row.old_provider_cat_agreement_type_id"
							filterable
							clearable
							placeholder="Seleccionar">
						<el-option
								v-for="(item,key) in catalogs.catAgreementType"
								:key="key"
								:label="item.name"
								:value="item.id">
						</el-option>
					</el-select>
				</template>
			</el-table-column>

			<el-table-column
					prop="date"
					label=""
					min-width="150">

				<template slot-scope="scope">

					<el-input v-model="scope.row.old_provider_name"
					          :disabled="onlyRead== true ? true: false"
					          placeholder=""/>

				</template>
			</el-table-column>


				<el-table-column
						prop="periodStart"
						label=""
						min-width="120">

					<template slot-scope="scope">
						<el-date-picker
								:disabled="onlyRead== true ? true: false"
								:editable="false"
								@change="scope.row.old_provider_period_end = null"
								v-model="scope.row.old_provider_period_start"
								type="date"
								placeholder="Selecciona una fecha"
								style="width: 100%"
								format="dd/MM/yyyy"
								value-format="yyyy-MM-dd">
						</el-date-picker>
					</template>


				</el-table-column>
				<el-table-column
						prop="periodEnd"
						label=""
						min-width="120">

					<template slot-scope="scope">
						<el-date-picker
								:picker-options="pickerOptions(scope.row.old_provider_period_start)"
								:disabled="scope.row.old_provider_cat_agreement_type_id == 2 || onlyRead== true ? true: false"
								:editable="false"
								v-model="scope.row.old_provider_period_end"
								type="date"
								placeholder="Selecciona una fecha"
								style="width: 100%"
								format="dd/MM/yyyy"
								value-format="yyyy-MM-dd">
						</el-date-picker>
					</template>
				</el-table-column>


			<el-table-column
					prop="monthlyCost"
					label=""
					min-width="210">
				<template slot-scope="scope">



					<vue-numeric currency="$"
					             :disabled="onlyRead== true ? true: false"
					             class="el-input__inner"
					             separator=","
					             v-model="scope.row.old_provider_monthly_cost"
					             :precision="2"
					></vue-numeric>

				</template>
			</el-table-column>


			<el-table-column label="" min-width="250">
				<template slot-scope="scope">
					<el-input v-model="scope.row.folioSHCP"
					          :disabled="scope.row.old_provider_cat_agreement_type_id == 2 ||onlyRead== true ? true: false"
					          placeholder="">
					</el-input>
				</template>
			</el-table-column>

			<el-table-column label="" align="center" min-width="80">
				<template slot-scope="scope">
					<div>
						<el-button-group>
							<el-tooltip
									class="item"
									effect="dark"
									content="Eliminar"
									placement="top-end">
								<el-button
										:disabled="onlyRead== true ? true: false"
										size="small"
										type="danger"
										@click="removePreviousSupplierAlias(scope.row)">
									<i class="fas fa-trash"></i>
								</el-button>
							</el-tooltip>
						</el-button-group>
					</div>
				</template>

			</el-table-column>

		</el-table>

	</div>
</template>

<script>
	import {mapState, mapGetters, mapActions, mapMutations} from "vuex";

	export default {
		components: {

		},
		computed: {
			...mapGetters("form", {
				requestForm: "requestForm",
				catalogs: "catalogs",
				general: "general",
				onlyRead: "onlyRead"
			}),
		},
		methods: {
			...mapMutations('form', {
				addPreviosSuppliers : "addPreviosSuppliers",
				removePreviousSupplier :"removePreviousSupplier"
			}),
			removePreviousSupplierAlias(item) {

				this.$confirm('¿Desea eliminar este documento?').then(confirm => {
					this.removePreviousSupplier(item);
				}).catch(e => {

				});

			},
			pickerOptions(date){

				return {
					disabledDate(time) {
						if(!date){
							return true;
						}
						let day =  moment(date);
						return time.getTime() < day;
					}
				}

			}
		}
	}
</script>

<style>
	.custom-table-other .el-table__header-wrapper{
		height: 0px;
	}
</style>